import {Directive, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {HttpSearchListResponse} from '@js-dot/api/operator';
import {NgClassToggle} from '@ng-dot/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {MainComponentBase} from './main-component-base';

@Directive()
/**
 * PageMagicComponent 와 연동되는 **다중** 출력 컴포넌트 기반
 *
 * @see MainComponentBase
 * @see PageMagicComponent
 */
export abstract class MainListComponentBase<T = any> extends MainComponentBase implements OnInit {

	@ViewChild('_createLink_', {static: true}) _createLink_!: TemplateRef<any>;

	protected _emptySelector: NgClassToggle;
	protected _items!: T[];

	/**
	 * _fetcher 속성이 있을 때 자동으로 _fetcher.load(this)를 시도 합니다.
	 */
	protected _baseAutoFetch = true;

	/**
	 * 출력 항목
	 */
	items$: Subject<T[] | HttpSearchListResponse<T>> | BehaviorSubject<T[] | HttpSearchListResponse<T>> = new BehaviorSubject<T[]>(null);

	/**
	 * 출력 항목 수량
	 */
	total$ = new BehaviorSubject<number>(0);

	listKey = 'seq';

	protected constructor(
		public feature?: string
	) {
		super();

		const element = this._injector.get(ElementRef).nativeElement;
		element.classList.add('list-component');
		this._emptySelector = new NgClassToggle(element, '_empty');
	}

	ngOnInit() {
		const {feature, _injector, total$, items$} = this;

		if (!feature) {
			return;
		}


		const target = this._translate.define(feature);

		if (!this._hasHeading) {
			this._setHeading(target);
		}

		const {_takeUntilDestroy, _act} = this;

		items$
			.pipe(_takeUntilDestroy)
			.subscribe((items: any) => {
				if (!items) {
					return total$.next('0' as any);
				}

				if (Array.isArray(items)) {
					total$.next(items.length);
				} else if ('total' in items) {
					total$.next(items['total']);
				} else if ('meta' in items && 'total' in items['meta']) {
					total$.next(items['meta']['total']);
				}
			});

		// const {defaultDescriptionForList} = this._layout.configure.titles;

		total$
			.pipe(_takeUntilDestroy)
			.subscribe(total => {
				const textValues = {
					total,
					feature: target
				};

				if (total || total === 0) {
					this._act.get$('$found', textValues).then(text => {
						this._setDescription(text);
					})
				} else {
					this._setDescription(null);
				}
			});

		if (this._baseAutoFetch && this['_fetcher'] && typeof this['_fetcher']['load'] === 'function') {
			setTimeout(() => {
				const _fetcher = this['_fetcher'];
				if (this['_phrase'] && this['_phrase']['load$']) {
					this['_phrase'].load$
						.subscribe(() => {
							_fetcher.load(this);
						})
				} else {
					if (!_fetcher.fetchInit) {
						_fetcher.load(this);
					}
				}
			});
		}
	}

	protected _setItems(items: T[]) {
		this._items = items as any;
		(<Subject<any>>this.items$).next(items);
		return this;
	}

	// listEmptied() {
	// 	this._emptySelector.set();
	// }
	//
	// listFilled() {
	// 	this._emptySelector.pop();
	// }
}
